<template>
	<v-card>
		<v-card-title class="title font-weight-bold white--text primary">{{ LocationSelected.DivisionName }}: {{ LocationSelected.LocationName }}</v-card-title>
		<v-divider></v-divider>
		<v-layout row wrap>
			<v-flex xs12 sm7 md7 lg8 xl9>
				<v-container v-if="HaveSessionData" class="ma-0 pa-0">
					<v-layout row>
						<v-flex v-for="data in LocationSelected.SessionData" :key="data.ID" shrink>
							<v-card style="width: 800px;">
								<v-card-title class="subheading font-weight-bold">Latest NuPoint Activity</v-card-title>
								<v-divider></v-divider>
								<v-list dense>
                  <v-list-tile>
                    <div class="NuPointCardRow">
                      <v-list-tile-content class="NuPointCardLabel">Job Type:</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ data.JobType }}</v-list-tile-content>
                    </div>
                    <div style="width: 50px;"></div>
                    <div class="NuPointCardRow">
                    <v-list-tile-content class="NuPointCardLabel">Job Status:</v-list-tile-content>
										<v-list-tile-content class="align-end">{{ data.JobStatus }}</v-list-tile-content>
                    </div>
									</v-list-tile>
                  <v-list-tile>
                    <div class="NuPointCardRow">
                      <v-list-tile-content class="NuPointCardLabel">Scheduled Start Time:</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ data.ScheduledStartTimeLocal }}</v-list-tile-content>
                    </div>
                    <div style="width: 50px;"></div>
                    <div class="NuPointCardRow">
                      <v-list-tile-content class="NuPointCardLabel">Scheduled End Time:</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ data.ScheduledEndTimeLocal }}</v-list-tile-content>
                    </div>
									</v-list-tile>
									<v-list-tile>
                    <div class="NuPointCardRow">
                      <v-list-tile-content class="NuPointCardLabel">Actual Start Time:</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ data.ActualStartTimeLocal }}</v-list-tile-content>
                    </div>
                    <div style="width: 50px;"></div>
                    <div class="NuPointCardRow">
                      <v-list-tile-content class="NuPointCardLabel">Actual End Time:</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ data.ActualEndTimeLocal }}</v-list-tile-content>
                    </div>
									</v-list-tile>
									<v-list-tile>
                    <div class="NuPointCardRow">
                      <v-list-tile-content class="NuPointCardLabel">Withhold End Time:</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ data.WithholdEndTimeLocal }}</v-list-tile-content>
                    </div>
                    <div style="width: 50px;"></div>
                    <div class="NuPointCardRow">
                      <v-list-tile-content class="NuPointCardLabel">Spray Hours:</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ data.SprayHours }}</v-list-tile-content>
                    </div>
									</v-list-tile>
									<v-list-tile>
										<v-list-tile-content>{{ data.Notes }} </v-list-tile-content>
									</v-list-tile>
								</v-list>
                <v-divider></v-divider>
                <v-card-title class="subheading font-weight-bold">Products Used</v-card-title>
								<v-divider></v-divider>
                 <v-flex v-for="data in data.Products" :key="data.ID" shrink>
                 <v-card-title class="font-weight-bold" style="font-size: 14px;">{{data.Label}}</v-card-title>
                  <v-list dense>
                    <v-list-tile>
                      <div class="NuPointCardRow">
                        <v-list-tile-content class="NuPointCardLabel">Type:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ data.Type }}</v-list-tile-content>
                      </div>
                      <div style="width: 50px;"></div>
                      <div class="NuPointCardRow">
                        <v-list-tile-content class="NuPointCardLabel">Active Ingredient:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ data.ActiveIngredient }}</v-list-tile-content>
                      </div>
                    </v-list-tile>
                    <v-list-tile>
                      <div class="NuPointCardRow">
                        <v-list-tile-content class="NuPointCardLabel">ICA:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ data.ICA }}</v-list-tile-content>
                      </div>
                      <div style="width: 50px;"></div>
                      <div class="NuPointCardRow">
                        <v-list-tile-content class="NuPointCardLabel">PHF:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ data.PHF }}</v-list-tile-content>
                      </div>
                    </v-list-tile>
                  </v-list>
                </v-flex>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
export default {
	props: {
		locationSelected: {
			type: Object,
			required: true
		}
	},
	data(){
		return {

		}
	},
	computed: {
		LocationSelected(){
			return this.locationSelected;
		},
		LocationVarieties() {
			if (this.LocationSelected && this.LocationSelected.Varieties) {
				return this.LocationSelected.Varieties;
			} else {
				return [];
			}
		},
		HaveSessionData: function () {
			if (this.LocationSelected && this.LocationSelected.SessionData && this.LocationSelected.SessionData.length > 0) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {

	}
}
</script>